import { motion } from "framer-motion";
import { WHY, IMAGES } from "@/data/content";
import { Rise } from "@/components/motion/Reveal";

export default function About() {
  return (
    <section
      id="why"
      data-testid="about-section"
      className="py-24 lg:py-32 bg-[#F4F4F5] text-[#0A0A0A] border-t border-[#E4E4E7]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <Rise className="lg:col-span-5">
            <div className="text-xs tracking-[0.24em] uppercase text-black/50 mb-4">
              — Why ElectroMax
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-bold leading-[0.95]">
              Not your average
              <br />
              <span className="text-[#E60000]">electrician.</span>
            </h2>
            <p className="mt-6 text-base md:text-lg text-black/65 leading-relaxed max-w-md">
              We&rsquo;re a Vancouver-based crew of journeymen electricians who treat
              your home or business the way we&rsquo;d treat our own. Fewer callbacks,
              cleaner installs, and no upselling.
            </p>
            <div className="mt-8 relative border border-[#E4E4E7] overflow-hidden">
              <img
                src={IMAGES.about}
                alt="ElectroMax electrician on-site at a Metro Vancouver residential job"
                className="w-full h-[320px] object-cover transition-transform duration-[1400ms] ease-out hover:scale-[1.04]"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/70 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 p-5">
                <div className="text-[10px] tracking-[0.24em] uppercase text-white/85">
                  {new Date().getFullYear() - 12}+ years serving Metro Vancouver
                </div>
              </div>
            </div>
          </Rise>

          <div className="lg:col-span-7">
            <motion.div
              className="grid sm:grid-cols-2 gap-px bg-[#E4E4E7] border border-[#E4E4E7]"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              variants={{
                hidden: {},
                show: { transition: { staggerChildren: 0.1 } },
              }}
            >
              {WHY.map((w) => (
                <motion.div
                  key={w.n}
                  data-testid={`why-item-${w.n}`}
                  className="bg-white p-6 md:p-8 group hover:bg-[#FAFAFA] transition-colors"
                  variants={{
                    hidden: { opacity: 0, y: 24 },
                    show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
                  }}
                >
                  <div className="flex items-baseline gap-3">
                    <span className="font-display text-4xl md:text-5xl font-black text-[#E60000]/80 group-hover:text-[#E60000] transition-colors">
                      {w.n}
                    </span>
                    <span className="text-[10px] tracking-[0.24em] uppercase text-black/40">
                      ElectroMax Standard
                    </span>
                  </div>
                  <h3 className="mt-4 font-display text-xl md:text-2xl tracking-tight font-bold text-black">
                    {w.h}
                  </h3>
                  <p className="mt-3 text-sm md:text-base text-black/65 leading-relaxed">
                    {w.p}
                  </p>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
